import { getLanguageCode } from 'utils/translation'

const GEOMANIST_VARIANTS_REGEX = /\b(2xl|3xl|4xl|5xl|6xl|7xl|8xl|9xl)\b/

const DEFAULT_SELECTORS = ['a', 'b', 'span']

export const getFontClass = (
  className?: string,
  customSelectors?: string[],
) => {
  const languageCode = getLanguageCode()
  const selectors = customSelectors || DEFAULT_SELECTORS

  const generateFontSelectors = (fontFamily: string) => {
    if (selectors.length === 0) {
      return `tw-font-${fontFamily}`
    }
    return [
      `tw-font-${fontFamily}`,
      ...selectors.map((selector) => `[&_${selector}]:tw-font-${fontFamily}`),
    ].join(' ')
  }

  if (languageCode === 'ja') {
    return generateFontSelectors('noto-jp')
  }
  if (languageCode === 'zh') {
    return generateFontSelectors('noto-sc')
  }
  if (className?.match(GEOMANIST_VARIANTS_REGEX)) {
    return generateFontSelectors('geomanist')
  }

  return generateFontSelectors('roboto')
}
